import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet, useStyleSheet, Text } from '@gopeerproject/ui-kit';
const weekdays = moment.weekdays().slice(1, 6);
export const Titles = () => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container }, weekdays.map((day, index) => (React.createElement(View, { key: day, style: [styles.wrapper, index !== 0 ? styles.wrapperWithMargin : {}] },
        React.createElement(Text, { type: 'body', size: 'sm', weight: 'semibold', style: styles.title }, day.substring(0, 3).toUpperCase()))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        width: 'calc(100% - 81px)'
    },
    wrapper: {
        flex: 1,
        width: size.M,
        height: size.M,
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        color: color.invert2.p56
    },
    wrapperWithMargin: {
        marginLeft: size.C
    }
}));
//# sourceMappingURL=Titles.js.map